module.exports = __webpack_public_path__ + "static/img/v5.5a8ec26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/v5.png
// module id = QHKq
// module chunks = 0